<template>
  <div class="BaseItem" @touchend="handleTouchEnd">
    <div class="item-label">
      <img src="./img/label-lt.png" class="item-label-lt" alt="" />
      <div class="item-label-text">{{ instance.instanceName }}</div>
      <img src="./img/lable-rt.png" class="item-label-rt" alt="" />
    </div>
    <div class="item-description">
      <div class="item-description-line"></div>
      <div class="item-description-text" v-html="instance.properties.description"></div>
      <div class="item-description-line"></div>
    </div>
    <div class="item-card">
      <label class="item-card-label">【墓园结构】</label>
      <ul class="item-card-list">
        <li class="card-list-item" v-for="(item1, i1) in helpObj[instance.instanceName]" :key="i1">
          <label class="cli-label">{{ item1.instanceName }}</label>
          <div class="cli-text" v-html="item1.description"></div>
        </li>
      </ul>
    </div>
    <div class="item-img-card">
      <label class="item-card-label">【相关图片】</label>

      <div class="list_box glzy_box">
        <div class="swiper_box" ref="swiper" @touchstart="handleTouchStartGL">
          <div class="inner_box">
            <div class="swiper_item" ref="swiperItem" v-for="(el2, i2) in instance.files" :key="i2"
              @click.stop="handleItemClick(el2)">
              <!-- <img v-if="el.materialCategory === 'KGS_LINKDATA_THREE_DIMENSION'" :src="`${el.filePath}`" /> -->
              <img :src="el2.filePath" />
              <div class="gl_label">
                <!-- <span class="span1">{{ el2.editorUserName }}</span> -->
                <span class="span2">{{ el2.materialTitle }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="line_box" v-if="instance.files.length >= 3">
          <div class="chunk_box" :class="{ acitve: i2 === glCurr }" v-for="(el2, i2) in instance.files" :key="i2"></div>
        </div>
        <p v-if="instance.files.length >= 3">左右滑动查看更多</p>
      </div>
    </div>

    <transition name="fade">
      <ImgViewer v-if="isImgShow" :instance="instance2" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseItem',
  data() {
    return {
      isImgShow: false,
      instance2: null,
      tpDom: null,
      glDom: null,
      tpCurr: 0,
      tpCurr_: -1,
      glCurr: 0,
      glCurr_: -1,
      speed: 200, // 拖动速率 越小越大
      helpObj: {}
    }
  },
  props: {
    instance: {
      type: Object,
      default: () => {}
    }
  },
  created() {},
  mounted() {
    this.glDom = this.$refs.swiper
    this.helpObj = JSON.parse(localStorage.getItem('jiegou'))
    setTimeout(() => {
      // this.tpDom = this.$refs.card
      this.figureResource(this.glCurr)
    }, 500)
  },
  beforeDestroy() {},
  components: {},
  computed: {
    glzyInfo() {
      return this.instance.files
    }
  },
  methods: {
    handleItemClick(item) {
      this.$linkWx({ instance: item.materialId, url: '/pages/ViewImage', imgPath: item.sourcePath })
    },
    // 计算资源卡片位置
    figureResource(curr) {
      let len = this.glzyInfo.length
      if (len < 3) return
      var mlen = Math.floor(len / 2)
      let cards = this.$refs.swiperItem
      var limg, rimg
      for (var i = 0; i < mlen; i++) {
        limg = len + curr - i - 1
        rimg = curr + i + 1
        if (limg >= len) {
          limg -= len
        }
        if (rimg >= len) {
          rimg -= len
        }

        cards[limg].style.transform = `translateX(${105 * (i + 1)}%) `
        cards[rimg].style.transform = `translateX(${-105 * (i + 1)}%)`
        cards[limg].style.opacity = 0
        cards[rimg].style.opacity = 0
      }
      cards[curr].style.transform = `translateX(0)`
      cards[curr].style.opacity = 1
    },
    // 手指按下触发事件

    // 关联资源
    handleTouchStartGL(e) {
      // e.preventDefault()
      // 拿到触摸点坐标
      const startX = e.touches[0].pageX
      // 开启触摸移动事件
      const _run = this._throttle(e => {
        let len = this.glzyInfo.length
        let deltaX = e.touches[0].pageX - startX
        let num = Math.round(deltaX / this.speed)
        if (num < -1) num = -1
        if (num > 1) num = 1
        this.glCurr_ = this.glCurr + num
        if (this.glCurr_ >= len) this.glCurr_ -= len
        if (this.glCurr_ < 0) this.glCurr_ += len
        this.figureResource(this.glCurr_)
      }, 15)
      this.glDom.ontouchmove = _run
    },
    // 手指抬起清除事件
    handleTouchEnd() {
      if (~this.glCurr_) {
        this.glCurr = this.glCurr_
        this.figureResource(this.glCurr_)
        this.glCurr_ = -1
      }
      this.glDom && (this.glDom.ontouchmove = null)
    },
    _throttle(callback, delay) {
      let previousCall = new Date().getTime()
      return function () {
        const time = new Date().getTime()

        // 如果距离上一次函数调用的时间已经超过给定的时间量delay，那么执行函数回调
        if (time - previousCall >= delay) {
          previousCall = time
          callback.apply(this, arguments)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.BaseItem {
  width: 100%;
  .item-label {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 3.75rem;
    height: 1.1rem;
    // margin: 0 auto;
    margin: 1rem auto 0.6rem auto;
    // padding-top: 1rem;
    .item-label-lt,
    .item-label-rt {
      width: 0.46rem;
      height: 0.66rem;
    }
    .item-label-text {
      color: #75592c;
      font-size: 0.72rem;
      font-family: '楷体';
      // font-family: 'wenDing';
    }
  }
  .item-description {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;

    width: 9.68rem;
    margin: 0 auto 1.2rem auto;

    .item-description-line {
      position: relative;

      width: 9.5rem;
      border-top: 0.01rem solid #bd8e40;
    }

    .item-description-line::before {
      position: absolute;
      top: -0.14rem;
      left: -0.08rem;
      content: '';
      width: 0.07rem;
      height: 0.27rem;
      border: 0.01rem solid #c5aa7e;
    }
    .item-description-line::after {
      position: absolute;
      top: -0.14rem;
      right: -0.08rem;
      content: '';
      width: 0.07rem;
      height: 0.27rem;
      border: 0.01rem solid #c5aa7e;
    }
    .item-description-text {
      // margin: 0.45rem 0;
      width: 9.6rem;

      color: #4c4948;
      font-size: 0.44rem;
      font-family: '楷体';
    }
  }
  .item-card {
    width: 10.26rem;
    margin: 0 auto 1.2rem auto;

    .item-card-label {
      display: inline-block;

      width: 100%;
      padding: 0 0.1rem;
      margin-bottom: 0.75rem;

      color: #ab7f35;
      font-size: 0.5rem;
    }
    .item-card-list {
      display: flex;
      flex-direction: column;
      background-color: rgba($color: #fff, $alpha: 0.8);
      border-radius: 0.2rem;

      width: inherit;
      padding: 0 0.4rem;
      .card-list-item {
        width: 9.38rem;

        font-size: 0.44rem;
        font-family: 'sySong';

        .cli-label {
          display: inline-block;
          margin-top: 0.6rem;
          margin-bottom: 0.3rem;

          color: #caa05a;
        }
        .cli-text {
          padding-bottom: 0.6rem;
          border-bottom: 0.01rem dashed #caa05a;

          color: #4c4948;
          text-align: justify;
        }
      }
      .card-list-item:last-child {
        .cli-text {
          border-bottom: none;
        }
      }
    }
  }
  .item-img-card {
    width: 10.26rem;

    margin: 0 auto;

    .item-card-label {
      display: inline-block;

      width: 100%;
      padding: 0 0.1rem;
      margin-bottom: 0.75rem;

      color: #ab7f35;
      font-size: 0.5rem;
    }
    .list_box {
      font-family: 'fzSong';

      width: 100%;
      padding: 0 0.22rem;
      // margin-bottom: 1.82rem;
      .item_title {
        font-size: 0.5rem;
        color: #ab7f35;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 0.84rem;
      }

      .content_box1 {
        line-height: 0.75rem;
        padding: 0.43rem 0;
        border-top: 1px solid #ab7f35;
        border-bottom: 1px solid #ab7f35;
        position: relative;
        .chunk {
          position: absolute;
          width: 0.07rem;
          height: 0.27rem;
          border: 1px solid #ab7f35;
          background-color: #fdfeef;
        }

        .chunk1 {
          top: 0;
          left: 0;
          transform: translateY(-50%);
        }
        .chunk2 {
          top: 0;
          right: 0;
          transform: translateY(-50%);
        }
        .chunk3 {
          bottom: 0;
          left: 0;
          transform: translateY(50%);
        }
        .chunk4 {
          bottom: 0;
          right: 0;
          transform: translateY(50%);
        }
      }

      .p_spe {
        margin-top: 0.3rem;
        font-size: 0.38rem;
        text-align: center;
      }
    }
    .glzy_box {
      .swiper_box {
        width: 100%;
        height: 7.05rem;
        // background-color: #ccc;
        overflow: hidden;
        .inner_box {
          width: 100%;
          height: 100%;
          position: relative;
          .swiper_item {
            transition: all 0.3s ease-in-out;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            // background-color: #f4f4e6;
            line-height: 1;
            img {
              width: 100%;
              height: 100%;
            }
            .video-icon {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.5);
              left: 0;
              top: 0;

              i {
                color: #fff;
                position: absolute;
                right: 0.6rem;
                bottom: 1.22rem;
                font-size: 1rem;
              }
            }
            .gl_label {
              width: 100%;
              font-family: '楷体', 'KaiTi', '楷体_GB2312', serif;
              padding-left: 0.4rem;
              position: absolute;
              height: 1rem;
              bottom: 0;
              font-size: 0.38rem;
              line-height: 1rem;
              background-color: rgba(0, 0, 0, 0.8);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              .span1 {
                color: #b4b3b3;
              }
              .span2 {
                color: #fff;
              }
            }
          }
        }
      }

      .line_box {
        margin: 0.3rem 0;
        height: 0.06rem;
        // background-color: #ccc;
        display: flex;
        .chunk_box {
          width: 100%;
          height: 100%;
        }
        .chunk_box.acitve {
          background-color: #ccc;
        }
      }

      p {
        text-align: center;
        font-size: 0.38rem;
      }
    }
  }
}
</style>